/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_accionProyecto as accionProyecto,
  rec_Bo as Bo,
  rec_EstadoError as EstadoError,
  rec_Gi as Gi,
  rec_JSXRuntime as JSXRuntime,
  rec_NuevaMeta as NuevaMeta,
  rec_Qx as Qx,
  rec_React as React,
  rec_Ro as Ro,
  rec_Ti as Ti,
  rec_Yx as Yx,
  rec_api as api,
  rec_fS as fS,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function MetasProyecto({ proyecto: e }) {
  let [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)(!0),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(!1),
    l = !accionProyecto(e, `planner.metas.crear`) && !accionProyecto(e, `planner.metas.editar`),
    u = (0, React.useCallback)(async () => {
      i(!0);
      try {
        (n(await api(`/metas?proyecto=${e.id}`)), o(``));
      } catch (e) {
        o(e.message);
      } finally {
        i(!1);
      }
    }, [e.id]);
  return (
    (0, React.useEffect)(() => {
      u();
    }, [u]),
    r ? (
      <div
        className={`flex items-center gap-2 text-sm text-(--text)`}
        children={[
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          }),
          ` Cargando…`,
        ]}
      />
    ) : (
      <div
        className={`flex flex-col gap-4`}
        children={[
          <div
            className={`flex items-center justify-between`}
            children={[
              <span
                className={`text-sm text-(--text)`}
                children={[t.length, ` metas`]}
              />,
              !l && (
                <button
                  type={`button`}
                  onClick={() => c(!0)}
                  className={Ro}
                  children={[
                    <Ti className={`mr-1 inline h-4 w-4`} />,
                    ` Nueva meta`,
                  ]}
                />
              ),
            ]}
          />,
          <EstadoError mensaje={a} onReintentar={u} />,
          t.length === 0 ? (
            <div
              className={`rounded-2xl border border-dashed border-(--border) p-10 text-center`}
              children={[
                <Gi className={`mx-auto h-8 w-8 text-(--text)`} />,
                <p
                  className={`mt-2 text-sm text-(--text)`}
                  children={`Sin metas. Agrupa tareas hacia un resultado con fecha.`}
                />,
              ]}
            />
          ) : (
            <ul
              className={`flex flex-col gap-3`}
              children={t.map((e) => (
                <li
                  key={e.id}
                  className={Bo}
                  children={[
                    <div
                      className={`flex flex-wrap items-center gap-2`}
                      children={[
                        <span
                          className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                          children={e.titulo}
                        />,
                        <span
                          className={`rounded-full px-2 py-0.5 text-xs ${Qx(e.estado)}`}
                          children={Yx(e.estado)}
                        />,
                        e.fechaObjetivo && (
                          <span
                            className={`text-xs ${e.atrasada ? `font-medium text-(--error)` : `text-(--text)`}`}
                            children={[`Objetivo `, fS(e.fechaObjetivo)]}
                          />
                        ),
                      ]}
                    />,
                    e.descripcion && (
                      <p
                        className={`mt-1 text-sm text-(--text)`}
                        children={e.descripcion}
                      />
                    ),
                    <div
                      className={`mt-2 flex items-center gap-2`}
                      children={[
                        <div
                          className={`h-2 flex-1 overflow-hidden rounded-full bg-(--border)`}
                          children={
                            <div
                              className={`h-full rounded-full bg-(--accent)`}
                              style={{
                                width: `${e.avance ?? 0}%`,
                              }}
                            />
                          }
                        />,
                        <span
                          className={`text-xs text-(--text)`}
                          children={[
                            e.avance ?? 0,
                            `% · `,
                            e.tareasCompletadas,
                            `/`,
                            e.totalTareas,
                            ` tareas`,
                          ]}
                        />,
                      ]}
                    />,
                  ]}
                />
              ))}
            />
          ),
          s && (
            <NuevaMeta proyectoId={e.id} onClose={() => c(!1)} onGuardado={u} />
          ),
        ]}
      />
    )
  );
}
